module.exports = __webpack_public_path__ + "static/media/women-avatar.144ee93c.svg";